import * as React from 'react';
import {Navigate, Routes as RoutesDOM, Route, useLocation} from 'react-router-dom';
import {routes} from './routes';
import {NotFoundScreen} from '../../screens/NotFoundScreen';

export const Router = () => {
    const {pathname} = useLocation();

    React.useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return (
        <RoutesDOM>
            {routes.map((route) => (
                <Route key={route.path} path={route.path} Component={route.component} />
            ))}
            <Route path='/' element={<Navigate replace to='/sample-screen' />} />
            <Route path='*' element={<NotFoundScreen />} />
        </RoutesDOM>
    );
};
